import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

const Menu = () => {
  return (
    <Nav aria-label="Primary">
      <MenuList>
        <MenuItem>
          <MenuLink to="/about" end>
            About
          </MenuLink>
        </MenuItem>

        <MenuItem>
          <MenuLink to="/self-hypnosis">
            Self Hypnosis
          </MenuLink>
        </MenuItem>

        <MenuItem>
          <MenuLink to="/hypnotherapy">
            Hypnotherapy
          </MenuLink>
        </MenuItem>

        <MenuItem>
          <MenuLink to="/group-hypnosis">
            Group Hypnosis
          </MenuLink>
        </MenuItem>
      </MenuList>
    </Nav>
  );
};

const Nav = styled.nav`
  padding: 12px 16px 4px;
  background: transparent;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (min-width: 1000px) {
    display: none;
  }
`;

const MenuList = styled.ul`
  width: 100%;
  max-width: 560px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const MenuItem = styled.li`
  width: 100%;
`;

const MenuLink = styled(NavLink)`
  /* Layout */
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 14px 16px;
  border-radius: 999px;

  /* Type */
  font-family: var(--font-heading), sans-serif;
  font-weight: 800;
  letter-spacing: 0.02em;
  font-size: 1.5rem;
  line-height: 1.1;

  /* Color */
  color: var(--ink);

  /* Subtle "card" feel */
  background: transparent;
  border: 1px solid transparent;

  /* Motion */
  transition: background 160ms ease, border-color 160ms ease, transform 160ms ease, color 160ms ease;

  &:hover {
    background: rgba(255, 119, 200, 0.12); /* brand pink, soft */
    border-color: var(--border);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0px);
  }

  /* Current page */
  &.active {
    background: var(--surface);
    border-color: var(--border);
    box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04);
  }

  /* Optional: small accent dot to keep brand presence */
  &::after {
    content: "";
    width: 8px;
    height: 8px;
    border-radius: 99px;
    margin-left: 10px;
    background: transparent;
    border: 2px solid transparent;
    transition: background 160ms ease, border-color 160ms ease;
  }

  &:hover::after {
    background: var(--brand-pink);
    border-color: transparent;
  }

  &.active::after {
    background: var(--brand-green);
    border-color: transparent;
  }

  @media (min-width: 500px) {
    font-size: 2rem;
    padding: 16px 18px;
  }
`;

export default Menu;
